__turbopack_context__.v({
  "card": "ServicesBlock-module__9kJJEq__card",
  "cardDesc": "ServicesBlock-module__9kJJEq__cardDesc",
  "cardTitle": "ServicesBlock-module__9kJJEq__cardTitle",
  "fadeUp": "ServicesBlock-module__9kJJEq__fadeUp",
  "fadeUpAnim": "ServicesBlock-module__9kJJEq__fadeUpAnim",
  "floatAnim": "ServicesBlock-module__9kJJEq__floatAnim",
  "icon": "ServicesBlock-module__9kJJEq__icon",
  "imageWrapper": "ServicesBlock-module__9kJJEq__imageWrapper",
  "section": "ServicesBlock-module__9kJJEq__section",
  "text": "ServicesBlock-module__9kJJEq__text",
  "title": "ServicesBlock-module__9kJJEq__title",
});
